import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    mainContent: {
        maxWidth: '1200px',
        margin: '0 auto',
    },

    caption: {
        color: tokens.colorNeutralForeground3,
    },

    smallRadius: {
        ...shorthands.borderRadius(tokens.borderRadiusSmall),
    },

    grayBackground: {
        backgroundColor: tokens.colorNeutralBackground3,
    },

    logoBadge: {
        ...shorthands.padding("5px"),
        ...shorthands.borderRadius(tokens.borderRadiusSmall),
        backgroundColor: "#FFF",
        boxShadow:
            "0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)",
    },
    cartContainer: {
        width: 'calc(100% - 300px)',
        float: 'left',
    },
    featuredFlag: {
        backgroundColor: 'rgb(0, 120, 212)',
        color: 'white',
        width: '100px',
        padding: '0.5em',
    },
    featuredText: {
    }
});

export default useStyles;